import React, { useEffect, useState } from 'react';
import './BeginChallengeTag.scss';
import {
  ChallengeTeamdashboardStatus,
  rectBadgeClassname,
} from '../../../common/challengeConstants';

const BeginChallengeTag = ({ status, teamMissing, challengeDay }) => {
  let tagText;
  if (status === ChallengeTeamdashboardStatus.begin_add_member) {
      tagText = `${rectBadgeClassname[status]?.text} ${teamMissing} ${rectBadgeClassname[status]?.textAfter}`;
  } else if (
      status === ChallengeTeamdashboardStatus.begin_weight_end ||
      status === ChallengeTeamdashboardStatus.end_challenge || 
      status === ChallengeTeamdashboardStatus.reward_period
  ) {
      tagText = 'จบการแข่งขัน';
  } else  if (challengeDay && status === ChallengeTeamdashboardStatus.ongoing) {
      tagText += ` ${challengeDay}`;
  } else {
      tagText = rectBadgeClassname[status]?.text;
  }
 
  return status ? (
    <div className="challenge-tag">
      <button className={`tag-button ${(rectBadgeClassname[status]?.tagClassName || rectBadgeClassname[status].classname)}`}>
        {rectBadgeClassname[status]?.iconUrl && (
          <img src={rectBadgeClassname[status]?.iconUrl} alt="Tag icon" />
        )}
        {tagText}
      </button>
    </div>
  ) : null;
};

export default BeginChallengeTag;
